import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { PaymentApi, RequestStrategyEnum, type WithSignal, type DepositPaymentsResponse } from '@shared/api';

const getPaymentByIdEffect = createEffect(({ signal, ...request }: WithSignal<{ id: string }>) => PaymentApi.getPaymentById(request.id, signal));
const clearEvent = createEvent();

const $dataStore = createStore<DepositPaymentsResponse | null>(null)
  .on(getPaymentByIdEffect.done, (_, data) => data.result.data ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getPaymentByIdEffect.pending, (_, data) => data)
  .on(getPaymentByIdEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getPaymentByIdEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getPaymentByIdEffect, () => null)
  // .on(getPaymentByIdEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getPaymentByIdEffect.fail, (_, data) => {
    if (data.error.message === 'Action is forbidden.') return 'Action is forbidden.';
    if (data.error.message === "'Id' must not be empty.") return 'Action is forbidden.';
    if (data.error.message === 'Forbidden account') return 'Action is forbidden.';
    return 'Something went wrong while fetching Transaction. Please try again.';
  })
  .on(getPaymentByIdEffect.done, () => null)
  .reset(clearEvent);

const getPaymentByIdApi = ApiUtils.wrapperApi(getPaymentByIdEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getPaymentByIdApi.cancel());

export const $paymentByIdStore = {
  events: {
    getPaymentById: getPaymentByIdApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
